import { sendDeviceTrack } from '@/api/device'
import Fingerprint2 from 'fingerprint'
import Store from 'store'
var userAgent = (window.navigator.userAgent || '').toLowerCase();

const guid = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,
          v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
  });
}

function getOS () {
  var os;
  //We extract the OS from the user agent (respect the order of the if else if statement)
  if(userAgent.indexOf("windows phone") >= 0){
    os = "Windows Phone";
  } else if(userAgent.indexOf("win") >= 0){
    os = "Windows";
  } else if(userAgent.indexOf("android") >= 0){
    os = "Android";
  } else if(userAgent.indexOf("linux") >= 0){
    os = "Linux";
  } else if(userAgent.indexOf("iphone") >= 0 || userAgent.indexOf("ipad") >= 0 ){
    os = "iOS";
  } else if(userAgent.indexOf("mac") >= 0){
    os = "Mac";
  } else{
    os = "Other";
  }
  
  return os;
}

function trim (str) {
  return (str + '').replace(/^\s+|\s+$/ig, '');
}

function getOSVersion () {
  var deviceInfo = getDeviceInfo();
  if (deviceInfo) {
    var dArr = deviceInfo.split(';');
    return dArr.length > 1 ? trim(dArr[1]) : deviceInfo;
  } else {
    var index = userAgent.indexOf('/');
    return userAgent.slice(index + 1);
  }
}


function getBrowser () {

  //we extract the browser from the user agent (respect the order of the tests)
  var browser;
  if(userAgent.indexOf("firefox") >= 0){
    browser = "Firefox";
  } else if(userAgent.indexOf("opera") >= 0 || userAgent.indexOf("opr") >= 0){
    browser = "Opera";
  } else if(userAgent.indexOf("safari") >= 0 && userAgent.indexOf('chrome') == -1){
    browser = "Safari";
  } else if(userAgent.indexOf("chrome") >= 0){
    browser = "Chrome";
  } else if(userAgent.indexOf("trident") >= 0){
    browser = "Internet Explorer";
  } else{
    browser = "Other";
  }
  return browser
}

function getBrowserVersion () {
  var browser = getBrowser();
  var reg = new RegExp(browser + '/\\d+((\\.\\d+)+)?', 'ig');
  var match = navigator.userAgent.match(reg);
  if (match) {
    return match[0];
  } else {
    return '';
  }
}

function getwxVersion () {
  var match = navigator.userAgent.match(/MicroMessenger\/([0-9.]+)\s+?/);
  if (match) {
    return match[1] || 'other';
  } else {
    return 'other';
  }
}

function getConnection () {
  var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (connection) {
    var type = connection.effectiveType || connection.type || '';
    if (type == 'wifi' || type == 'cellular') {
      if (connection.downlinkMax >= 100) {
        return '4G';
      } else if (connection.downlinkMax > 4 && connection.downlinkMax < 100) {
        return 'WIFI';
      } else {
        return '2G/3G';
      }
    } else if (type == '4g') {
      return '4G';
    }
  } else {
    return '';
  }
}

function getDeviceInfo() {
  var match = navigator.userAgent.match(/\(.+?\)/ig);
  if (match) {
    return (match[0] || '').replace(/\(|\)/ig, '');
  } else {
    return '';
  }
}

function getDeviceType () {
  var deviceInfo = getDeviceInfo();
  if (deviceInfo) {
    var dArr = deviceInfo.split(';');
    return dArr.length > 2 ? trim(dArr[2]) : deviceInfo;
  } else {
    return 'unknow';
  }
}

export default {
  state: {
    isDone: false,
    platform: 'h5', // platform,
    os: getOS(),
    requestHref: window.location.href,
    appName: window.navigator.appName,
    appCodeName: window.navigator.appCodeName,
    appVersion: window.navigator.appVersion,
    language: window.navigator.language,
    osVersion: getOSVersion(),
    browserVersion: getBrowserVersion(),
    wxVersion: getwxVersion(),
    netType: getConnection(),
    deviceType: getDeviceType(),
    trueIp: '',
    latitude: 0,
    longitude: 0,
    deviceId: '',
    gpsFailReason: '',
    tokenId: ''
  },
  mutations: {
    'SET_DEVICE_INFO' (state, data) {
      for(var i in state) {
        if (state.hasOwnProperty(i) && data.hasOwnProperty(i)) {
          state[i] = data[i];
        }
      }
    },
    'SET_IS_DONE' (state, done) {
      state.isDone = done;
    },
    'SET_FAIL_REASON' (state, reason) {
      state.gpsFailReason = reason;
    },
    'SET_DEVICE_PLATFORM' (state, info) {
      var arr = info.split('/');
      var platform = "h5";

      if (!info) {
        return;
      }
      for (var i = 0; i < arr.length; i++) {
        if (i === 2 && arr[i].toLowerCase() === "touch") {
          platform = "h5";
          break;
        }
        if (i === 4) {
          if (arr[i] === "5") {
            platform = "h5-ios";
          } else if (arr[i] === "6") {
            platform = "h5-android";
          }
        }
      }
      state.platform = platform;
    }
  },
  actions: {
    collect ({ commit }) {
      var geoDone = false, deviceDone = false;
      function done () {
        if (geoDone && deviceDone) {
          commit('SET_IS_DONE', true);
        }
      }
      function geoCallback(pos) {
        let { latitude, longitude } = pos.coords;
        commit('SET_DEVICE_INFO', {
          latitude,
          longitude
        });
        geoDone = true;
        done();
      }
      function geoError (err) {
        geoDone = true;
        commit('SET_FAIL_REASON', '用户未授权-' + err.message);
        done();
      }

      try {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(geoCallback, geoError);
        } else {
          geoDone = true;
          commit('SET_FAIL_REASON', '浏览器不支持')
          done();
        }

        new Fingerprint2().get(function (result) {
          if (!result) {
            commit('SET_FAIL_REASON', '获取不到设备ID');
          }
          commit('SET_DEVICE_INFO', {deviceId: result});
          deviceDone = true;
          done();
        });
      } catch (e) {
        geoDone = true;
        deviceDone = true;
        commit('SET_FAIL_REASON', e.message)
        done()
      }
    },
    track ({ state, commit }, payload) {
        let { applyId = 0, eventName = '', eventValue = '', eventParameter = {} } = payload;
        if (!(state.longitude && state.latitude)) {
          commit('SET_FAIL_REASON', '获取失败');
        }

        state.tokenId = Store.get("tokenMD5");

        return sendDeviceTrack(guid(), applyId, eventName, eventValue, eventParameter, state.platform, state.os, state.requestHref, state.appName, state.appCodeName, state.appVersion, state.osVersion, state.browserVersion, state.wxVersion, state.netType, state.deviceType, state.trueIp, state.latitude, state.longitude, state.deviceId, state.language, state.tokenId, state.gpsFailReason)
    },
    trackSubmit ({ state, commit }, payload) {
      let { func, event = {}, param = {} } = payload;
      let eventDataByMiracle = {
        productId: "DM-QBXJ",
        userId: event.userId + "",
        applyId: event.applyId + "",
        platform: state.platform,
        eventName: event.eventName,
        eventParameter: JSON.stringify(event.eventParameter)
      }
      const TRACK_EVENTS = ["Confirm_Sign"]

      if (TRACK_EVENTS.indexOf(event.eventName) === -1) {
        return func(param);
      }

      param.eventDataByMiracle = JSON.stringify(eventDataByMiracle);
      return func(param);
    }
  }
}
